import TranslationApiModel from '@v/models/TranslationApiModel.js'
import CustomFieldApiModel from './CustomFieldApiModel.js'
import IntegrationFieldApiModel from './IntegrationFieldApiModel.js'
import DurationType from '@v/inventory/products/edit/models/DurationType.js'

export default class {
  constructor(rawModel) {
    this.ActiveSegments = rawModel?.ActiveSegments || null // { [classification]: string[] }
    this.Exclusivity = rawModel?.Exclusivity || 'None'
    this.AvailableOnline =
      typeof rawModel?.AvailableOnline === 'boolean' ? rawModel.AvailableOnline : true
    this.Enabled = typeof rawModel?.Enabled === 'boolean' ? rawModel.Enabled : true
    this.Key = rawModel?.Key || null
    this.ModifiedDuration = rawModel?.ModifiedDuration || null // string
    this.DurationPerNrOfParticipants = rawModel?.DurationPerNrOfParticipants || null
    this.NameInternal = rawModel?.NameInternal || null
    this.PluNumber = rawModel?.PluNumber || null
    this.Position = rawModel?.Position || null // number
    this.PriceIncludesTax = rawModel?.PriceIncludesTax || false
    this.Price = rawModel?.Price || 0 // number
    this.PriceType = rawModel?.PriceType || 'PerPerson'
    this.ModifiedCapacity = rawModel?.ModifiedCapacity || null
    this.ExternalType = rawModel?.ExternalType || null
    this.ResourceKey = rawModel?.ResourceKey || null
    this.ShowInProgram =
      typeof rawModel?.ShowInProgram === 'boolean' ? rawModel.ShowInProgram : true
    this.TaxKey = rawModel?.TaxKey || null
    this.UseDefaultNumberOfPeople =
      typeof rawModel?.UseDefaultNumberOfPeople === 'boolean'
        ? rawModel.UseDefaultNumberOfPeople
        : true
    this.Description = rawModel?.Description || null
    this.NameExternal = rawModel?.NameExternal || null
    this.Image = rawModel?.Image || null
    this.ScheduleInParallel = rawModel?.ScheduleInParallel || false
    this.ImageHorizontalAlignment = rawModel?.ImageHorizontalAlignment || ''
    this.ImageVerticalAlignment = rawModel?.ImageVerticalAlignment || ''
    this.ExternalProductIds = rawModel?.ExternalProductIds || []
    this.LedgerAccountKey = rawModel?.LedgerAccountKey || null
    this.CostCenterKey = rawModel?.CostCenterKey || null
    this.DiscountLedgerAccountKey = rawModel?.DiscountLedgerAccountKey || null
    this.DiscountCostCenterKey = rawModel?.DiscountCostCenterKey || null
    this.CustomFields = rawModel?.CustomFields?.map(x => new CustomFieldApiModel(x)) || []
    this.IntegrationFields =
      rawModel?.IntegrationFields?.map(x => new IntegrationFieldApiModel(x)) || []
    this.TranslationInfo = new TranslationApiModel(rawModel?.TranslationInfo) || null
    this.ParallelStartExtension = rawModel?.ParallelStartExtension || null // string
    this.ParallelEndExtension = rawModel?.ParallelEndExtension || null // string
    this.MinimumDuration = rawModel?.MinimumDuration || null // string
    this.MaximumDuration = rawModel?.MaximumDuration || null // string
    this.StartDuration = rawModel?.StartDuration || null // string
    this.ResetTimeDuration = rawModel?.ResetTimeDuration || null // string
    this.ApplicableResetTimeIso = rawModel?.ApplicableResetTimeIso || null // string
    this.ProductDurationConfig = rawModel?.ProductDurationConfig || new ProductDurationConfigModel()
    this.MinimumPrice = rawModel?.MinimumPrice || null // number
    this.MaximumPrice = rawModel?.MaximumPrice || null // number
  }
}

class ProductDurationConfigModel {
  constructor() {
    this.CustomDuration = null
    this.DurationType = DurationType.FixedDuration
    this.MaximumDuration = null
    this.MinimumDuration = null
    this.NumberOfParticipantsPerDuration = null
    this.ParallelExtraTimeAtEnd = null
    this.ParallelExtraTimeBeforeStart = null
    this.ResetTime = null
    this.ResourceDuration = null
    this.ResourceResetTime = null
    this.ResourceResetTimeType = null
    this.StartDuration = null
    this.UseResourceDuration = true
  }
}
